import useOcapiSite from './useOcapiSite'

/**
 * Tells whether Brightcove videos render as a native `<video>` instead of the Brightcove player.
 *
 * @returns {boolean} True when the site preference is on and the account id is set.
 * @example
 * const nativeVideo = useBrightcoveNativeVideoEnabled()
 */
export const useBrightcoveNativeVideoEnabled = () => {
    const {accountId, brightcoveNativeVideoEnabled} = useOcapiSite()
    return Boolean(brightcoveNativeVideoEnabled && accountId)
}
